// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__234up","rootSuccess":"CompleteLink_rootSuccess__Y3vNz","rootFailure":"CompleteLink_rootFailure__3RcDQ","isDisabled":"CompleteLink_isDisabled__3jXWr"};